import React, {Component} from 'react';
import axios from 'axios';
import {toast} from 'react-toastify';

const $ = window.$;
export default class ModalDeleteBanner extends Component {
    constructor(props) {
        super(props);

        this.state = {
            banner: null,
            loading: false
        }

        this.deleteBanner = this.deleteBanner.bind(this);
    }

    componentWillReceiveProps(props) {
        this.setState({
            banner : props.banner
        })
    }

    deleteBanner() {
        this.setState({
            loading: true
        });

        axios.post(global.config.apiDomain + '/rest/promoBannerSellMic/deletePromoBannerSellMic', JSON.stringify(this.state.banner), {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            this.setState({
                loading: false
            });

            $("#modalDeleteBanner").modal("hide");

            toast.success('Xoá banner khuyến mãi thành công'); 
            this.props.resetList();
        })
    }

    render() {

        const {banner} = this.state;

        return (
            <>
                <div className="modal fade" id="modalDeleteBanner" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    Xoá banner khuyến mãi bán mic
                                </h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            {banner ? (
                                <div className="modal-body">
                                <h3 className="text-center text-danger">
                               Bạn chắc chắn muốn xoá banner khuyến mãi
                                </h3>
                            </div>
                            ) : ""}
                            <div className="modal-footer">
                                <button type="button" className="btn btn-red" data-dismiss="modal">Hủy</button>
                                {this.state.loading ? 
                                (
                                <button style={{width: "120px"}} className="btn btn-red" type="button" disabled>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Xác nhận...
                                </button>
                                ) :
                                (
                                <button 
                                    style={{width: "120px"}} 
                                    type="button" 
                                    className="btn btn-red"
                                    onClick={this.deleteBanner}>
                                      Xoá
                                    </button>                            
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}